enum Environment {
  LOCALHOST = 'localhost',
  DEV = 'dev.cohort.proserve.aws.dev',
  PROD = 'cohort.proserve.aws.dev',
}

interface EnvConfig {
  environment: string;
  apiBaseUrl: string;
  awsRegion: string;
  cognitoUserPoolId: string;
  cognitoUserPoolClientId: string;
  cognitoIdentityPoolId: string;
  cognitoAppDomain: string;
  cognitoRedirectUri: string;
  maintenanceMode: boolean;
}

type ConfigKey = Exclude<keyof EnvConfig, 'maintenanceMode'>;

const environments: Record<Environment, EnvConfig> = {
  [Environment.LOCALHOST]: {
    environment: 'localhost',
    apiBaseUrl: 'https://api.dev.cohort.proserve.aws.dev',
    awsRegion: 'us-east-1',
    cognitoUserPoolId: 'us-east-1_zk8NSDwKa',
    cognitoUserPoolClientId: '6gpggrlpm9vo4fndruejlr3uil',
    cognitoIdentityPoolId: 'us-east-1:4be33cc6-1fac-409e-9431-e74453d6f82d',
    cognitoAppDomain: 'https://cohort-manager-dev.auth.us-east-1.amazoncognito.com',
    cognitoRedirectUri: 'http://localhost:3000',
    maintenanceMode: false,
  },

  [Environment.DEV]: {
    environment: 'dev',
    apiBaseUrl: 'https://api.dev.cohort.proserve.aws.dev',
    awsRegion: 'us-east-1',
    cognitoUserPoolId: 'us-east-1_zk8NSDwKa',
    cognitoUserPoolClientId: '6gpggrlpm9vo4fndruejlr3uil',
    cognitoIdentityPoolId: 'us-east-1:4be33cc6-1fac-409e-9431-e74453d6f82d',
    cognitoAppDomain: 'https://cohort-manager-dev.auth.us-east-1.amazoncognito.com',
    cognitoRedirectUri: 'https://dev.cohort.proserve.aws.dev',
    maintenanceMode: false,
  },

  [Environment.PROD]: {
    environment: 'prod',
    apiBaseUrl: 'https://api.cohort.proserve.aws.dev',
    awsRegion: 'us-east-1',
    cognitoUserPoolId: 'us-east-1_NW4CFfufA',
    cognitoUserPoolClientId: '7of1h5jmrj101kelh2sljbgj7c',
    cognitoIdentityPoolId: 'us-east-1:62c06998-6dc4-478e-bd63-e7a4d9f5ff1d',
    cognitoAppDomain: 'https://cohort-manager-prod.auth.us-east-1.amazoncognito.com',
    cognitoRedirectUri: 'https://cohort.proserve.aws.dev',
    maintenanceMode: true,
  },
};

export default function getEnvVar(key: ConfigKey): string {
  const isLocalhost = window.location.hostname === 'localhost';

  const environment = isLocalhost
    ? Environment.LOCALHOST
    : (window.location.hostname as Environment);

  if (!(environment in environments)) {
    console.error(`Missing environment configuration for "${environment}".`);
    return '';
  }

  const config = environments[environment];
  if (!(key in config)) {
    console.error(`Missing environment variable "${key}".`);
    return '';
  }
  return config[key];
}

export function isMaintenanceMode(): boolean {
  const isLocalhost = window.location.hostname === 'localhost';
  const environment = isLocalhost
    ? Environment.LOCALHOST
    : (window.location.hostname as Environment);
  return environments[environment]?.maintenanceMode ?? false;
}
